import { render, staticRenderFns } from "./AssignmentsList.vue?vue&type=template&id=52b1be3d&scoped=true&"
import script from "./AssignmentsList.vue?vue&type=script&lang=js&"
export * from "./AssignmentsList.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentsList.vue?vue&type=style&index=0&id=52b1be3d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b1be3d",
  null
  
)

export default component.exports